module.exports = __webpack_public_path__ + "static/img/15.b23171d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/17/eng/15.png
// module id = /rqu
// module chunks = 0